import {
    ConfirmActionModal,
    IConfirmActionModal
} from 'components/site/modals/ModalWrapper/ModalContent/contents/ConfirmActionModal';
import {
    GalleryModal,
    IGalleryModal
} from 'components/site/modals/ModalWrapper/ModalContent/contents/GalleryModal';
import { MobileModal } from 'components/site/modals/ModalWrapper/ModalContent/contents/MobileModal';
import { ShareModal } from 'components/site/modals/ModalWrapper/ModalContent/contents/ShareModal';
import { UpgradeModal } from 'components/site/modals/ModalWrapper/ModalContent/contents/UpgradeModal';
import { useContext } from 'react';
import { CtxModal } from 'session/ctxModal';

export enum EModal {
    CONFIRM = 1,
    UPGRADE,
    SHARE,
    MOBILE,
    GALLERY,
    EDIT,
    EDIT2
}

export enum EModalColor {
    WHITE = 'white',
    ORANGE = 'orange',
    GREY = 'grey',
    GREY2 = '#F7F9FF'
}

export interface IModalProperties {
    content: JSX.Element;
    color: EModalColor;
    widthPC?: number;
}

export const useGetModalProperties = () => {
    const ctxModal = useContext(CtxModal);

    function getModal(): IModalProperties {
        switch (ctxModal.modal?.type) {
            case EModal.CONFIRM:
                return {
                    content: (
                        <ConfirmActionModal data={ctxModal.modal.data as IConfirmActionModal} />
                    ),
                    color: EModalColor.ORANGE,
                    widthPC: 500
                };
            case EModal.UPGRADE:
                return {
                    content: <UpgradeModal />,
                    color: EModalColor.WHITE,
                    widthPC: 780
                };
            case EModal.SHARE:
                return {
                    content: <ShareModal />,
                    color: EModalColor.WHITE,
                    widthPC: 550
                };
            case EModal.MOBILE:
                return {
                    content: <MobileModal />,
                    color: EModalColor.WHITE,
                    widthPC: 400
                };
            case EModal.GALLERY:
                return {
                    content: <GalleryModal data={ctxModal.modal.data as IGalleryModal} />,
                    color: EModalColor.GREY,
                    widthPC: 780
                };
            case EModal.EDIT:
                return {
                    content: <>{ctxModal.modal.data}</>,
                    color: EModalColor.GREY2,
                    widthPC: 600
                };
            case EModal.EDIT2:
                return {
                    content: <>{ctxModal.modal.data}</>,
                    color: EModalColor.GREY2,
                    widthPC: 800
                };
        }
    }

    return {
        getModal
    };
};
